import { render, staticRenderFns } from "./ActiveHomeDashboard.vue?vue&type=template&id=dc64c586&scoped=true&"
import script from "./ActiveHomeDashboard.vue?vue&type=script&lang=ts&"
export * from "./ActiveHomeDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveHomeDashboard.vue?vue&type=style&index=0&id=dc64c586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc64c586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
